import { DetailFormSelect } from 'components/DetailsView';
import { SubcategoryState, useGetSubcategoriesOfCategoryQuery } from 'data/__generated__';
import styled from 'styled-components';

export const SubcategorySelector = ({ categoryId }: { categoryId: string }) => {
    const { data: subcategoriesData } = useGetSubcategoriesOfCategoryQuery({ variables: { categoryId } });

    if (!subcategoriesData) {
        return null;
    }

    const { subcategoriesOfCategory } = subcategoriesData;

    const subcategoryOptions = subcategoriesOfCategory
        .filter(({ state }) => state === SubcategoryState.Regular)
        .map(({ _id, name }) => ({ value: _id, label: name }));

    return (
        <Row key={categoryId}>
            ↳
            <DetailFormSelect<string>
                label="Sous-catégorie"
                placeholder="Sélectionner une sous-catégorie"
                name="subcategoryId"
                options={subcategoryOptions}
                dataTest="product-subcategory"
                isClearable
            />
        </Row>
    );
};

const Row = styled.div`
    display: flex;
    flex-direction: row;
    color: white;
    gap: 5px;
`;
